import SecurityApi from 'api/securityApi';
import { createMessage } from 'utils/commonUtils';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { LoginResponseDTO, LoginRequestDTO } from 'types';
import CompanyApi from 'api/companyApi';
import { setAppSetting, setBranchInfo } from 'myredux/globalSlice';
import { setData } from 'myredux/loginSlice';

let login: ReturnType<typeof createAsyncThunk<LoginResponseDTO, LoginRequestDTO>>;

export function initLogin() {
    login = createAsyncThunk('auth/login', async (_data: LoginRequestDTO, { dispatch, rejectWithValue }) => {
        const loginRes = (await SecurityApi.login(_data)).data;
        if (loginRes.status !== 'success') {
            createMessage('warning', loginRes.message);
            return rejectWithValue(loginRes.message);
        }

        dispatch(setData(loginRes.data));
        dispatch(setBranchInfo(loginRes.data));
        const settingRes = (await CompanyApi.getCompanyAppSetting()).data;
        if (settingRes.status !== 'success') {
            createMessage('error', 'Nepodařilo se načíst nastavení aplikace. Zkuste prosím později.');
            return rejectWithValue(settingRes.message);
        }
        dispatch(setAppSetting(settingRes.data));
        return loginRes.data;
    });
}

export function processLogin() {
    return login;
}
